import ms from 'ms';

import { EMPTY_OBJ } from '@constants';

import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useAssetsList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'assets', api: api.assets }, queryVariables, queryConfig);

  return {
    assets: queryResult.resolvedData,
    latestAssets: queryResult.latestData,
    ...queryResult,
  };
};

export const useAsset = ({ id, language = 'en' }, queryConfig = {}) => {
  const queryResult = useQuery(['asset', { id, language }], api.assets.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    asset: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'assets' });

export const useDeleteAsset = createMutation(api.assets.remove);

export const useCreateAsset = createMutation(api.assets.create);

export const usePublishAsset = createMutation(api.assets.publish);

export const useUpdateAsset = createMutation(api.assets.update);

export const useUnpublishAsset = createMutation(api.assets.unpublish);

export const useDuplicateAsset = createMutation(api.assets.duplicate);

export const useAssetTypeList = (queryVariables = {}, queryConfig = {}) => {
  const { data: assetTypes = [], ...queryResult } = useQuery(['assetTypes', queryVariables], api.assets.getTypeList, {
    cacheTime: ms('5m'),
    queryConfig,
  });

  return {
    assetTypes,
    ...queryResult,
  };
};
